export default "__VITE_ASSET__Ct09jweR__"